/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=2d4e0b9c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2d4e0b9c&lang=css"

import exportComponent from "E:\\projects\\git\\company\\www_dixiang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__